import { render, staticRenderFns } from "./RecycleQueue.vue?vue&type=template&id=e3ea583c"
import script from "./RecycleQueue.vue?vue&type=script&lang=js"
export * from "./RecycleQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports